import { InMemoryDbService } from "angular-in-memory-web-api";

import { environment } from "../../environments/environment";
import { HomeStatisticsFakeDb } from "./home-statistics";
import { RegisterUserFakeDb } from "./register-user";
import { LoginUserFakeDb } from "./login-user";
import { ForgotPasswordFakeDb } from "./forgot-password";
import { ResetPasswordFakeDb } from "./reset-password";
import { RosterTasksFakeDb } from "./roster-tasks";
import { IncidentsFakeDb } from "./incidents";
import { AccountsFakeDb } from "./accounts";
import { DocumentsNotes } from "./documents&notes";
import { ClientsFakeDb } from "./clients";
import { AdminsFakeDb } from "./admins";
import { SuppliersFakeDb } from "./suppliers";
import { UploadFilesFakeDb } from "./upload-files";
import { ResourcesFakeDb } from "./resources";
import { InterviewsResourcesFakeDb } from "./interviews-resources";
import { ComplianceFakeDb } from "./compliance";
import { SuppliersResources } from "./suppliers-resources";
import { VerifyEmailFakeDb } from "./verify-email";
import { ResendVerificationFakeDb } from "./resend-verification";
import { InvitationsFakeDb } from "./invitations";
import { AuditLogFakeDb } from "./audit-log";
import { IncidentReportSchema } from "./incident-report-schema";
import { ReportsFakeDb } from "./reports";
import { LocationsFakeDb } from "./locations";
import { VenuesFakeDb } from "./venues";
import { ComplianceAndOperationsFakeDb } from "./complianceAndOperations";
import { InductionRequirementsFakeDb } from "./inductionRequirements";
import { CriteriaRatesFakeDb } from "./criteriaRates";
import { ResourcesHistoryFakeDb } from "./resourcesHistory";
import { IncidentHistoryFakeDb } from "./incidentHistory";
import { VenueResourcesFakeDb } from "./venueResources";
import { ResourceWorkDataFakeDb } from "./resourceWorkData";
import { TemplatesFakeDb } from "./templates";
import { AssessmentsFakeDb } from "./assessments";
import { InterviewsAdmin } from "./interviews-admin";
// import { AccountsFakeDb } from './accounts';
import { ContactsFakeDb } from "./contacts";
import { PaymentPlaneFakeDb } from "./payment-plane";
import { MembersFakeDb } from "./members";
import { planeOfUserFakeDb } from "./planeOfUser";
import { ListAccreditationsFakeDb } from "./list-accreditations";
import { RolesOfResourcesFakeDb } from "./roles-of-resources";
import { ResourceInductionsFakeDb } from "./resource-inductions";
import { ResourceRatesFakeDb } from "./resource-rates";
import { ResourceAccreditationsFakeDb } from "./resource-accreditations";
import { ExternalInvitationsFakeDb } from "./external-invitations";
import { ConnectedVenuesFakeDb } from "./connectedVenues";
import { ShiftRolesFakeDb } from "./shift-roles";
import { BlueprintsFakeDb } from "./blueprints";
import {AssetLibraryFakeDb} from "./asset-library";
import { SkillsFakeDb } from "./skills";

export class FakeDbService implements InMemoryDbService {
  createDb(): any {
    return {
      // Statistic
      statistics: HomeStatisticsFakeDb.statistics,

      // Skills
      skills: SkillsFakeDb.skills,

      // Authentication
      register: RegisterUserFakeDb.users,
      login: LoginUserFakeDb.users,
      refresh: LoginUserFakeDb.refresh,
      "forgot-password": ForgotPasswordFakeDb.users,
      "reset-password": ResetPasswordFakeDb.users,
      verify: VerifyEmailFakeDb.users,
      "verify-email": ResendVerificationFakeDb.users,

      // Accounts
      accounts: AccountsFakeDb.accounts,
      "accounts-medinfo": AccountsFakeDb.medinfo,
      "account-formdata": AccountsFakeDb.formData,
      compliance: ComplianceFakeDb.accreditations,
      "compliance-security-nsw": ComplianceFakeDb.securityLicences,
      "compliance-abn": ComplianceFakeDb.abn,
      "compliance-acn": ComplianceFakeDb.acn,
      "licences": ComplianceFakeDb.licences,

      // Invite
      invitations: InvitationsFakeDb.invitations,
      "external-invitations": ExternalInvitationsFakeDb.externalInvites,

      // Admins
      admins: AdminsFakeDb.admins,

      //Audit Log
      auditlog: AuditLogFakeDb.logs,

      // My account
      "plan-account": planeOfUserFakeDb.plane,
      invoices: planeOfUserFakeDb.invoices,
      "controls-accounts": TemplatesFakeDb.controlsOfModal,

      // Documents
      documents: DocumentsNotes.documents,
      files: UploadFilesFakeDb.files,

      // Incidents
      incidents: IncidentsFakeDb.incidents,
      "incident-schema": IncidentReportSchema.schema,
      reports: ReportsFakeDb.reports,

      map: LocationsFakeDb.locations,

      // Clients
      clients: ClientsFakeDb.clients,
      entitytypes: ClientsFakeDb.entitytypes,
      controls: ClientsFakeDb.controlsWASecurity,
      types: ClientsFakeDb.typesWALiquor,
      accreditationTypes: ClientsFakeDb.accreditationTypes,
      contacts: ContactsFakeDb.contacts,

      "list-accreditations": ListAccreditationsFakeDb.accreditations,
      "list-user-defined-accreditations": ListAccreditationsFakeDb.userDefinedAccreditations,
      "roles-resources": RolesOfResourcesFakeDb.roles,

      // Venues
      connectedVenues: ConnectedVenuesFakeDb.venues,
      venues: VenuesFakeDb.venues,
      "venue-licences": VenuesFakeDb.NSWLicenceInfo,
      venuesDataTables: VenuesFakeDb.dataTables,
      venueResources: VenueResourcesFakeDb.resources,
      members: MembersFakeDb.members,
      "shift-roles": ShiftRolesFakeDb.roles,

      // Templates
      "assessment-templates": TemplatesFakeDb.templates,
      // 'register-data'       : TemplatesFakeDb.dataRegisterPage,
      assessments: AssessmentsFakeDb.assessments,
      operations: ComplianceAndOperationsFakeDb.operations,
      requirements: InductionRequirementsFakeDb.requirements,
      rates: CriteriaRatesFakeDb.rates,
      histories: ResourcesHistoryFakeDb.history,
      incidentHistories: IncidentHistoryFakeDb.histories,
      resourcesBreakdown: ResourceWorkDataFakeDb.workData,
      // Suppliers
      suppliers: SuppliersFakeDb.suppliers,

      // Roster
      "roster-tasks": RosterTasksFakeDb.tasks,
      "roster-shifts": RosterTasksFakeDb.shifts,
      "venue-tasks": RosterTasksFakeDb.venueTasks,
      "suppliers-resources": SuppliersResources.suppliers,

      // Resources
      resources: ResourcesFakeDb.resources,
      "resource-inductions": ResourceInductionsFakeDb.inductions,
      "resource-rates": ResourceRatesFakeDb.rates,
      "resource-accreditations": ResourceAccreditationsFakeDb.accreditations,
      resourcesRequirements: ResourcesFakeDb.venueResourceRequirements,
      controlsForNSWSecurityLicence:
        ResourcesFakeDb.controlsForNSWSecurityLicence,
      controlsForNSWResponsibleServiceOfAlcohol:
        ResourcesFakeDb.controlsForNSWResponsibleServiceOfAlcohol,
      controlsForVIKSecurityLicence:
        ResourcesFakeDb.controlsForVIKSecurityLicence,
      controlsForVICResponsibleServiceOfAlcohol:
        ResourcesFakeDb.controlsForVICResponsibleServiceOfAlcohol,
      controlsForQLDSecurityLicence:
        ResourcesFakeDb.controlsForQLDSecurityLicence,
      controlsForQLDResponsibleServiceOfAlcohol:
        ResourcesFakeDb.controlsForQLDResponsibleServiceOfAlcohol,
      controlsForWASecurityLicence:
        ResourcesFakeDb.controlsForWASecurityLicence,
      controlsForWAResponsibleServOfAlcohol:
        ResourcesFakeDb.controlsForWAResponsibleServOfAlcohol,

      // Interviews
      "interviews-admin": InterviewsAdmin.interviews,
      "interview-templates": InterviewsAdmin.templates,
      "interviews-resources": InterviewsResourcesFakeDb.interviews,
      "formbuilder-model": InterviewsResourcesFakeDb.formBuilderModel,
      "field-models": ComplianceFakeDb.fieldModels,
      // Notifications
      // 'notifications'        : NotificationsFakeDb.notifications

      // Asset Library

      "assetlibrary-templates": AssetLibraryFakeDb.templates,
      "assetlibrary-forms": AssetLibraryFakeDb.forms,

      // Payment Plane

      planesMonth: PaymentPlaneFakeDb.planesMonth,
      planesYear: PaymentPlaneFakeDb.planesYear,
    };
  }

  get(reqInfo: any): any {
    // Compliance Suite blueprints are nested under the `compliance` base URL,
    // so the in-memory API resolves them here instead of a top-level collection.
    // Serve the fixture for the list endpoint (…/suite/blueprints), honouring the
    // ?status= filter; sub-paths (…/versions, …/assignments) fall through. (TEZY2-4343)
    //
    // Gated to e2e ONLY: this fixture exists for cypress/e2e/blueprint-assignment-
    // display.cy.ts. Without the guard it also fires in local/dev/prod and shadows
    // the real …/suite/blueprints backend response, so the account's real
    // Onboarding Blueprints never load.
    const reqUrl: string = (reqInfo && reqInfo.req && reqInfo.req.url) || '';

    // Recurrence delete job status (TEZY2-4473) — e2e only. The progress card
    // polls GET …/jobs/{uuid}; return a completed task.series_delete job.
    if (environment.e2e && /\/jobs\/job-e2e-tsd/.test(reqUrl)) {
      return reqInfo.utils.createResponse$(() => ({
        status: 200,
        body: {
          job_uuid: 'job-e2e-tsd',
          type: 'task.series_delete',
          status: 'completed',
          progress: { done: 2, total: 2, unit: 'steps' },
          result: {
            deleted_tasks: 3,
            kept_tasks: 0,
            cancelled_tasks: 0,
            uncancelled_tasks: 0,
            deleted_shifts: 1,
            kept_shifts: 0,
          },
          error: null,
          created_at: '2026-10-02T00:00:00Z',
        },
      }));
    }

    // Shift duplication job status (TEZY2-4452) — e2e only. The panel polls
    // GET …/jobs/{uuid}; return a completed job so the flow reaches the result.
    if (environment.e2e && /\/jobs\//.test(reqUrl)) {
      return reqInfo.utils.createResponse$(() => ({
        status: 200,
        body: {
          job_uuid: 'job-e2e-1',
          type: 'shift.duplicate',
          status: 'completed',
          progress: { done: 4, total: 4, unit: 'shifts' },
          result: { created_shifts: 4 },
          error: null,
          created_at: '2026-09-15T00:00:00Z',
        },
      }));
    }

    if (environment.e2e && /\/suite\/blueprints$/.test(reqUrl)) {
      const statusParam =
        reqInfo.query && reqInfo.query.get ? reqInfo.query.get('status') : null;
      const status = Array.isArray(statusParam) ? statusParam[0] : statusParam;
      const all = BlueprintsFakeDb.blueprints;
      const body = status ? all.filter((b: any) => b.status === status) : all;
      return reqInfo.utils.createResponse$(() => ({ status: 200, body }));
    }

    if (reqInfo.collectionName === 'invitations') {
      try {
        const userId = localStorage.getItem('user_id');
        
        if (userId === '99999999') {
          return reqInfo.utils.createResponse$(() => {
            return {
              status: 200,
              body: []
            };
          });
        }
        
        const userEmail = localStorage.getItem('email');
        if (userEmail === 'welcome-no-account@test.com') {
          return reqInfo.utils.createResponse$(() => {
            return {
              status: 200,
              body: []
            };
          });
        }
      } catch (e) {
        console.warn('Could not access localStorage in FakeDbService.get:', e);
      }
    }

    return undefined;
  }

  post(reqInfo: any): any {
    const reqUrl: string = (reqInfo && reqInfo.req && reqInfo.req.url) || '';

    // Shift duplication enqueue (TEZY2-4452) — e2e only. Answer the 202 job
    // response the panel expects so the submit → poll → result flow works.
    if (environment.e2e && /\/shift\/duplicate/.test(reqUrl)) {
      const key =
        (reqInfo.req && reqInfo.req.body && reqInfo.req.body.idempotency_key) ||
        'e2e-key';
      return reqInfo.utils.createResponse$(() => ({
        status: 202,
        body: {
          job_uuid: 'job-e2e-1',
          status: 'pending',
          planned: { shifts: 4, tasks: 4 },
          skipped: [],
          warnings: [],
          skipped_total: 0,
          warnings_total: 0,
          idempotency_key: key,
        },
      }));
    }

    // Recurrence delete enqueue (TEZY2-4473 / TEZY2-4477) — e2e only. Answer
    // the 202 the dialog expects, with one skip reason so the summary renders.
    if (environment.e2e && /\/task\/series\/delete/.test(reqUrl)) {
      const body = (reqInfo.req && reqInfo.req.body) || {};
      const taskUuids: string[] = body.task_uuids || [];
      // A start date in 2099 has nothing on or after it: answer the backend's 422.
      if (/^2099-/.test(body.from_date || '')) {
        return reqInfo.utils.createResponse$(() => ({
          status: 422,
          body: {
            title: 'Unprocessable Entity',
            status: 422,
            detail: `no occurrence of the selected tasks is on or after ${body.from_date} and still on its source's pattern, there is nothing to delete`,
          },
        }));
      }
      return reqInfo.utils.createResponse$(() => ({
        status: 202,
        body: {
          job_uuid: 'job-e2e-tsd',
          status: 'pending',
          threads: taskUuids.map((uuid, i) => ({
            task_uuid: uuid,
            planned: { tasks: i === 0 ? 3 : 0 },
            cancelled: [],
            skipped: i === 0 ? [{ reason: 'PAST_DATE', count: 1 }] : [],
          })),
          planned: { tasks: 3, shifts: 1 },
          cancelled_total: 0,
          skipped_total: taskUuids.length ? 1 : 0,
          idempotency_key: body.idempotency_key || 'e2e-key',
        },
      }));
    }

    return undefined;
  }
}
